import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveProjectTypes() {
      try {
        const structure = await axios.get('/project-types', { withCredentials: true });
        return structure.data;
      } catch (error) {
        throw error;
      }
    },
    async createProjectTypes(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/project-types', data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    // async updateFolderStructure(context, data) {
    //   try {
    //     const config = { withCredentials: true };
    //     const response = await axios.patch(`/folder-structure/${data.type}`, data.data, config);
    //     return response.data;
    //   } catch (error) {
    //     throw error;
    //   }
    // },
  },
};
